// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file tournament/v1/tournament_api.proto (package tournament.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddTournamentParticipationRequest, AddTournamentParticipationResponse, AddTournamentPermissionUserRequest, AddTournamentPermissionUserResponse, AddTournamentRequest, AddTournamentResponse, ConfirmTournamentRequestRequest, ConfirmTournamentRequestResponse, CreateTournamentRequestRequest, CreateTournamentRequestResponse, DeleteTournamentRequest, DeleteTournamentResponse, ListTournamentPermissionUsersRequest, ListTournamentPermissionUsersResponse, ListTournamentRequestsRequest, ListTournamentRequestsResponse, ListTournamentsRequest, ListTournamentsResponse, ProcessTournamentRequestRequest, ProcessTournamentRequestResponse, RemoveTournamentParticipationRequest, RemoveTournamentParticipationResponse, RemoveTournamentPermissionUserRequest, RemoveTournamentPermissionUserResponse, UpdateTournamentRequest, UpdateTournamentResponse } from "./tournament_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * TournamentAPI service
 *
 * @generated from service tournament.v1.TournamentAPI
 */
export const TournamentAPI = {
  typeName: "tournament.v1.TournamentAPI",
  methods: {
    /**
     * @generated from rpc tournament.v1.TournamentAPI.AddTournament
     */
    addTournament: {
      name: "AddTournament",
      I: AddTournamentRequest,
      O: AddTournamentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tournament.v1.TournamentAPI.ListTournaments
     */
    listTournaments: {
      name: "ListTournaments",
      I: ListTournamentsRequest,
      O: ListTournamentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tournament.v1.TournamentAPI.AddTournamentParticipation
     */
    addTournamentParticipation: {
      name: "AddTournamentParticipation",
      I: AddTournamentParticipationRequest,
      O: AddTournamentParticipationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tournament.v1.TournamentAPI.RemoveTournamentParticipation
     */
    removeTournamentParticipation: {
      name: "RemoveTournamentParticipation",
      I: RemoveTournamentParticipationRequest,
      O: RemoveTournamentParticipationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tournament.v1.TournamentAPI.UpdateTournament
     */
    updateTournament: {
      name: "UpdateTournament",
      I: UpdateTournamentRequest,
      O: UpdateTournamentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tournament.v1.TournamentAPI.DeleteTournament
     */
    deleteTournament: {
      name: "DeleteTournament",
      I: DeleteTournamentRequest,
      O: DeleteTournamentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tournament.v1.TournamentAPI.ListTournamentPermissionUsers
     */
    listTournamentPermissionUsers: {
      name: "ListTournamentPermissionUsers",
      I: ListTournamentPermissionUsersRequest,
      O: ListTournamentPermissionUsersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tournament.v1.TournamentAPI.AddTournamentPermissionUser
     */
    addTournamentPermissionUser: {
      name: "AddTournamentPermissionUser",
      I: AddTournamentPermissionUserRequest,
      O: AddTournamentPermissionUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tournament.v1.TournamentAPI.RemoveTournamentPermissionUser
     */
    removeTournamentPermissionUser: {
      name: "RemoveTournamentPermissionUser",
      I: RemoveTournamentPermissionUserRequest,
      O: RemoveTournamentPermissionUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tournament.v1.TournamentAPI.CreateTournamentRequest
     */
    createTournamentRequest: {
      name: "CreateTournamentRequest",
      I: CreateTournamentRequestRequest,
      O: CreateTournamentRequestResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tournament.v1.TournamentAPI.ConfirmTournamentRequest
     */
    confirmTournamentRequest: {
      name: "ConfirmTournamentRequest",
      I: ConfirmTournamentRequestRequest,
      O: ConfirmTournamentRequestResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tournament.v1.TournamentAPI.ListTournamentRequests
     */
    listTournamentRequests: {
      name: "ListTournamentRequests",
      I: ListTournamentRequestsRequest,
      O: ListTournamentRequestsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tournament.v1.TournamentAPI.ProcessTournamentRequest
     */
    processTournamentRequest: {
      name: "ProcessTournamentRequest",
      I: ProcessTournamentRequestRequest,
      O: ProcessTournamentRequestResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

